import React from 'react';
import PropTypes from 'prop-types';
import { showWhenPermission } from '@/shared/components/security';
import RegistrationsPerReport from './RegistrationsPerReport';

const RegistrationsPerOwnCompanyContainer = ({ searchParams }) => (
  <RegistrationsPerReport
    externalParams={searchParams}
    reportType={10}
    reportKey="RegsPerOwnCompanyReport"
  />
);
RegistrationsPerOwnCompanyContainer.propTypes = {
  searchParams: PropTypes.shape({}),
};

RegistrationsPerOwnCompanyContainer.defaultProps = {
  searchParams: {},
};
export default showWhenPermission('RegistrationOwn', 'read')(RegistrationsPerOwnCompanyContainer);
